export const FETCH_CLIENTS = 'FETCH_CLIENTS';
export const FETCH_CLIENTS_OK = 'FETCH_CLIENTS_OK';
export const FETCH_CLIENTS_FAILED = 'FETCH_CLIENTS_FAILED';

export const ADD_CLIENT = 'ADD_CLIENT';
export const ADD_CLIENT_OK = 'ADD_CLIENT_OK';
export const ADD_CLIENT_FAILED = 'ADD_CLIENT_FAILED';

export const FETCH_CLIENT_ID = 'FETCH_CLIENT_ID';
export const FETCH_CLIENT_ID_OK = 'FETCH_CLIENT_ID_OK';
export const FETCH_CLIENT_ID_FAILED = 'FETCH_CLIENT_ID_FAILED';

export const PATCH_CLIENT = 'PATCH_CLIENT';
export const PATCH_CLIENT_OK = 'PATCH_CLIENT_OK';
export const PATCH_CLIENT_FAILED = 'PATCH_CLIENT_FAILED';

export const RESET_CLIENT = 'RESET_CLIENT';


